// CompletedOrders.js
import React, { useEffect, useState } from "react";
import { Table, Spin, message, Typography, Tag } from "antd";
import axios from "axios";
import SummaryApi from "../../../common/index";

const { Title } = Typography;

function CompletedOrders({ seller, token }) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCompletedOrders();
  }, []);

  const fetchCompletedOrders = async () => {
    setLoading(true);
    try {
      console.log("Fetching from:", SummaryApi.getCompletedOrders.url);
      const response = await axios.get(SummaryApi.getCompletedOrders.url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setOrders(response.data.orders || []);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch completed orders");
    }
    setLoading(false);
  };

  const columns = [
    {
      title: "Order Number",
      dataIndex: "order_number",
      key: "order_number",
      render: (number) => `${number || "N/A"}`,
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
      render: (_, record) => record.customer_name || `User ${record.userId || "-"}`,
    },
    {
      title: "Products",
      key: "products",
      render: (_, record) => (
        <span>{record.products.map((p) => p.product_name).join(", ")}</span>
      ),
    },
    {
      title: "Quantity",
      key: "quantity",
      render: (_, record) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          {record.products.map((p) => (
            <div key={p.product_id}>{p.quantity}</div>
          ))}
        </div>
      ),
    },
      {
      title: "Total Price",
      dataIndex: "total_price",
      key: "total_price",
      align: "center",
      render: (total) => `₹${total}`,
    },
    {
      title: "Order Date",
      dataIndex: "order_date",
      key: "order_date",
      render: (date) => (date ? new Date(date).toLocaleString() : "-"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <Tag color="green">{status || "N/A"}</Tag>,
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Title level={3} style={{ marginBottom: "20px" }}>
        Completed Orders
      </Title>
      {loading ? (
        <Spin tip="Loading completed orders..." size="large" />
      ) : (
        <Table
          dataSource={orders}
          columns={columns}
          rowKey="order_id"
          pagination={{ pageSize: 10 }}
          bordered
        />
      )}
    </div>
  );
}

export default CompletedOrders;
